export default __webpack_public_path__ + "static/media/inspiratorio.c6f45e15.png";